import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();

  if (document.body.classList.contains('contact') ) {
    topValidation();
  }


  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  const headerNavHeight = document.querySelector('.header')?.offsetHeight || 0;
  const anchorLinks = document.querySelectorAll('a[href^="#"]');

  anchorLinks.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href').slice(1);
      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;
      const screenWidth = window.innerWidth;

      // ページ内リンクでも余白を確実に保持
      requestAnimationFrame(() => {
        let targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerNavHeight - 50;

        if(screenWidth < 769){
          targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - 80;
        }

        gsap.to(window, {
          duration: 1,
          scrollTo: targetPosition,
          ease: 'power2.inOut'
        });
      });
    });
  });



  // CF7の遷移位置調整
  document.addEventListener('tccf7:scrollTo', e => {
    const header = document.querySelector('.anchor-header');
    const headerHeight = header ? header.offsetHeight : 0;

      const screenWidth = window.innerWidth;
      let offset = headerHeight + 100; // デフォルト
      if (screenWidth <= 1024) {
        offset = headerHeight * 0.3; // 1024px以下なら短く
      }

    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: "#" + e.detail.id,
        offsetY: offset
      },
      ease: "power2.inOut"
    });
  });



  const textElements = document.querySelectorAll('.animated-text');

  function wrapTextWithSpans(element) {
    const content = element.innerHTML; // innerHTMLを使用して、<br>タグも保持
    element.innerHTML = ""; // 元のテキストを消す

    // <br>で分割して、改行を考慮しつつ文字を分ける
    const parts = content.split(/(<br[^>]*>)/); // <br>タグを含めて分割

    parts.forEach((part, index) => {
      if (part.match(/<br[^>]*>/)) {
        // <br>タグの場合はそのまま追加
        const brTag = document.createElement('br');
        if (part.includes('class')) {
          // クラス付きの<br>の場合、クラスをコピー
          const classMatch = part.match(/class="([^"]*)"/);
          if (classMatch) {
            brTag.classList.add(classMatch[1]);
          }
        }
        element.appendChild(brTag);
      } else {
        // テキスト部分を<span>で囲む
        const lineWrapper = document.createElement('div'); // 各行をラップするdiv

        // 文字ごとに<span>を作成
        part.split("").forEach((word, index) => {
          const span = document.createElement("span");

          // 半角スペースなら &nbsp; に変換
          if (word === " ") {
            span.innerHTML = "&nbsp;";
          } else {
            span.textContent = word;
          }

          span.style.transitionDelay = `${index * 0.15}s`;
          lineWrapper.appendChild(span);
        });


        element.appendChild(lineWrapper);
      }
    });
  }

  // 各テキストに対して文字を<span>で囲む
  textElements.forEach(wrapTextWithSpans);
  ScrollTrigger.refresh();

  // Intersection Observerの設定
  const observerOptions = {
    threshold: 0.1, // 10%でも画面に入った時に発火
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 要素が画面内に入ったらアニメーション開始
        entry.target.classList.add('visible');
        observer.unobserve(entry.target); // 一度発火したら監視を停止
      }
    });
  }, observerOptions);

  // 各要素に対して監視を開始
  textElements.forEach(element => observer.observe(element));




  window.addEventListener("scroll", function () {
    document.querySelectorAll(".fadein-group").forEach(function (group) {
      var position = group.getBoundingClientRect().top + window.scrollY;
      var scroll = window.scrollY;
      var windowHeight = window.innerHeight;

      if (scroll > position - windowHeight + 200) {
        group.querySelectorAll(".fadein").forEach(function (element, i) {
          setTimeout(function () {
            element.classList.add("active");
          }, i * 300);
        });
      }
    });
  });




  const swiper = new Swiper(".post-slider", {
    loop: true,
    slidesPerView: 1.8,
    spaceBetween: 20,
    centeredSlides: true,
    speed: 1000,
    autoplay : {
      delay: 1000,
      disableOnInteraction: true,
    },
    breakpoints: {
      769: {
        slidesPerView: 4.2,
      }
    },
  });

    const worksSwiper = new Swiper(".works-slider", {
    loop: true,
    slidesPerView: 1.8,
    spaceBetween: 20,
    centeredSlides: true,
    speed: 1000,
    autoplay : {
      delay: 1000,
      disableOnInteraction: true,
    },
    breakpoints: {
      769: {
        slidesPerView: 4.2,
      }
    },
  });


  const menuBtn = document.querySelector('.menu-box');
  const head = document.querySelector('header');
  menuBtn.addEventListener('click',function(){
    this.classList.toggle('is-open');
    head.classList.toggle('is-open')
  });


  var rellax = new Rellax('.rellax', {
    // breakpoints:[576, 768, 1201]
  });


  // Lenis 初期化
  const lenis = new Lenis();
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);


  if(document.body.classList.contains('index')){
    const targets = document.querySelectorAll('.introduction-content');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 表示領域に20%以上入ったとき
          entry.target.classList.add('round');
        } else {
          // 20%未満になったとき（＝画面外に出たとき）
          entry.target.classList.remove('round');
        }
      });
    }, { threshold: 0.2 });

    targets.forEach(target => observer.observe(target));
  }




  document.addEventListener('scroll', () => {
    const sideBar = document.querySelector('.side-bar');
    if (!sideBar) return; // .side-barが存在しない場合は処理しない

    const screenWidth = window.innerWidth;
    if (screenWidth < 769) return; // 768px未満なら処理をしない

    const fixedArea = document.querySelector('.fixed-area');
    if (!fixedArea) return; // 念のため .fixed-area の存在も確認

    const scrollY = window.scrollY;

    const start = fixedArea.offsetTop;
    const end = start + fixedArea.offsetHeight - sideBar.offsetHeight - 200;

    if (scrollY < start) {
      sideBar.style.position = 'absolute';
      sideBar.style.top = '200px';
    } else if (scrollY >= start && scrollY < end) {
      sideBar.style.position = 'fixed';
      sideBar.style.top = '200px'; // 固定したい位置
    } else {
      sideBar.style.position = 'absolute';
      sideBar.style.top = `${fixedArea.offsetHeight - sideBar.offsetHeight}px`;
    }
  });

  // 画面リサイズ時にも追従位置をリセットしたい場合
  window.addEventListener('resize', () => {
    const sideBar = document.querySelector('.side-bar');
    if (!sideBar) return; // .side-barがないページでは処理しない

    if (window.innerWidth < 768) {
      sideBar.style.position = '';
      sideBar.style.top = '';
    }
  });



  const links = document.querySelectorAll('.side-bar a');

  function updateCurrent() {
    const screenHeight = window.innerHeight;
    const rangeStart = screenHeight * 0.35; // 上から5%
    const rangeEnd = screenHeight * 0.8;    // 上から80%

    let currentLink = null;

    links.forEach(link => {
      const targetId = link.getAttribute('href').replace('#', '');
      const target = document.getElementById(targetId);

      if (target) {
        const rect = target.getBoundingClientRect();
        const targetTop = rect.top;
        const targetBottom = rect.bottom;

        // 上端が上部5%を過ぎていて、下端が上部80%を過ぎていない場合
        if (targetTop <= rangeStart && targetBottom > rangeStart) {
          // 上にある方を優先
          if (!currentLink || targetTop < currentLink.targetTop) {
            currentLink = { link, targetTop };
          }
        }
      }
    });

    // すべてのリンクから current を削除
    links.forEach(link => link.classList.remove('current'));

    // 候補があれば current を付与
    if (currentLink) currentLink.link.classList.add('current');
  }

  window.addEventListener('scroll', updateCurrent);
  window.addEventListener('resize', updateCurrent);
  updateCurrent();






  // 対象となるボタンとサイドバーを取得
  const categoryBtns = document.querySelectorAll('.sp-category-btn, .side-bar a');
  const sideBar = document.querySelector('.side-bar');
  const spBtns = document.querySelectorAll('.sp-category-btn'); // 複数ある場合に対応

  categoryBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      // .side-bar のクラス付け外し
      sideBar.classList.toggle('is-open');

      // .sp-category-btn 全てにクラス付け外し
      spBtns.forEach(spBtn => spBtn.classList.toggle('is-open'));
    });
  });


  // JS（スクロール進捗連動）
  // パフォーマンスのため rAF を使う
  const els = document.querySelectorAll('.slide-progress');
  if (!els.length) return;

  let ticking = false;

  // スクロールに応じて右方向に動かす最大距離
  const moveDistance = 200; // ← 好きな値に調整

  function update() {
    const vh = window.innerHeight || document.documentElement.clientHeight;

    els.forEach(el => {
      const rect = el.getBoundingClientRect();
      const start = vh;
      const end = -rect.height;

      const progress = 1 - ((rect.top - end) / (start - end));
      const p = Math.max(0, Math.min(1, progress));

      // CSSの初期位置から右方向へ移動（左に動かしたいなら符号を変える）
      const tx = -moveDistance * p;
      el.style.transform = `translateX(${tx}px)`;
    });

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // 初回実行
  onScroll();






});